const pbTextingModalStyle = (theme) => ({
  dialogPaper: {
    maxWidth: 680,
    width: '95%',
    maxHeight: '90vh',
    borderRadius: 16,
    overflow: 'hidden',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      margin: 16,
      width: 'calc(100% - 32px)',
      borderRadius: 12,
      maxHeight: '85vh',
    },
  },
  headerBar: {
    background: 'linear-gradient(135deg, #5850EC 0%, #8B5CF6 50%, #7C3AED 100%)',
    padding: '28px 28px 24px',
    position: 'relative',
    flexShrink: 0,
    overflow: 'hidden',
    // Decorative glow effect
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      right: 0,
      width: 180,
      height: 180,
      background: 'radial-gradient(circle, rgba(255,255,255,0.15) 0%, transparent 70%)',
      borderRadius: '50%',
      transform: 'translate(30%, -30%)',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: 1,
      background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '22px 20px 18px',
    },
  },
  headerContent: {
    position: 'relative',
    zIndex: 1,
  },
  closeButton: {
    position: 'absolute',
    top: -6,
    right: -4,
    color: 'rgba(255, 255, 255, 0.85)',
    padding: 8,
    '&:hover': {
      color: '#ffffff',
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
    },
  },
  headline: {
    color: '#ffffff',
    fontSize: 24,
    fontWeight: 700,
    lineHeight: 1.35,
    margin: 0,
    paddingRight: 40,
    letterSpacing: '-0.02em',
    textShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
    [theme.breakpoints.down('sm')]: {
      fontSize: 19,
      paddingRight: 32,
    },
  },
  content: {
    padding: '24px 28px 20px',
    backgroundColor: '#ffffff',
    overflowY: 'auto',
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      padding: '18px 20px 14px',
    },
  },
  // Sunset Warning Section Styles
  sunsetWarning: {
    backgroundColor: '#FEF3C7',
    border: '1px solid #F59E0B',
    borderRadius: 10,
    padding: '14px 16px',
    marginBottom: 20,
    [theme.breakpoints.down('sm')]: {
      padding: '12px 14px',
      marginBottom: 16,
    },
  },
  sunsetWarningHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
    marginBottom: 10,
    [theme.breakpoints.down('sm')]: {
      gap: 8,
      marginBottom: 8,
    },
  },
  sunsetWarningIcon: {
    color: '#D97706',
    fontSize: 22,
    flexShrink: 0,
    marginTop: 1,
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
  },
  sunsetWarningTitle: {
    color: '#92400E',
    fontSize: 15,
    fontWeight: 600,
    lineHeight: 1.4,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
  sunsetRenewalInfo: {
    color: '#78350F',
    fontSize: 14,
    lineHeight: 1.5,
    marginBottom: 8,
    paddingLeft: 32,
    '& strong': {
      fontWeight: 600,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 13,
      paddingLeft: 28,
      marginBottom: 6,
    },
  },
  sunsetMessage: {
    color: '#92400E',
    fontSize: 13,
    fontWeight: 500,
    lineHeight: 1.45,
    paddingLeft: 32,
    fontStyle: 'italic',
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
      paddingLeft: 28,
    },
  },
  sunsetCta: {
    color: '#78350F',
    fontSize: 13,
    lineHeight: 1.5,
    marginTop: 10,
    paddingLeft: 32,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
      paddingLeft: 28,
      marginTop: 8,
    },
  },
  sunsetCtaLink: {
    color: '#5850EC',
    fontWeight: 600,
    textDecoration: 'underline',
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    fontSize: 'inherit',
    '&:hover': {
      color: '#4338CA',
    },
  },
  introText: {
    color: '#374151',
    fontSize: 15,
    lineHeight: 1.65,
    margin: '0 0 20px 0',
    padding: '12px 16px',
    borderLeft: '3px solid #5850EC',
    backgroundColor: '#F5F3FF',
    borderRadius: '0 8px 8px 0',
    '& strong': {
      color: '#5850EC',
      fontWeight: 600,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
      marginBottom: 16,
      padding: '10px 14px',
    },
  },
  videoDescription: {
    marginBottom: 12,
    fontSize: 14,
    color: '#666',
    fontStyle: 'italic',
    lineHeight: 1.5,
    [theme.breakpoints.down('sm')]: {
      fontSize: 13,
      marginBottom: 10,
    },
  },
  videoSection: {
    marginTop: 24,
    padding: 16,
    backgroundColor: '#F9FAFB',
    border: '1px solid #E5E7EB',
    borderRadius: 8,
    [theme.breakpoints.down('sm')]: {
      marginTop: 20,
      padding: 12,
    },
  },
  videoTabs: {
    display: 'flex',
    gap: 8,
    marginBottom: 16,
    [theme.breakpoints.down('sm')]: {
      gap: 6,
      marginBottom: 12,
    },
  },
  videoTab: {
    flex: 1,
    padding: '10px 16px',
    fontSize: 14,
    fontWeight: 500,
    border: 'none',
    borderRadius: 8,
    cursor: 'pointer',
    transition: 'all 0.15s ease',
    backgroundColor: '#E5E7EB',
    color: '#374151',
    '&:hover': {
      backgroundColor: '#D1D5DB',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '8px 12px',
      fontSize: 13,
    },
  },
  videoTabActive: {
    backgroundColor: '#5850EC',
    color: '#ffffff',
    '&:hover': {
      backgroundColor: '#4338CA',
    },
  },
  videoWrapper: {
    borderRadius: 10,
    overflow: 'hidden',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    border: '1px solid #E5E7EB',
    [theme.breakpoints.down('sm')]: {
      borderRadius: 8,
    },
  },
  videoContainer: {
    position: 'relative',
    width: '100%',
    paddingBottom: '56.25%', // 16:9 aspect ratio
    backgroundColor: '#1a1a2e',
    '& iframe': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      border: 'none',
    },
  },
  benefitsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    marginBottom: 24,
    padding: '14px 18px',
    backgroundColor: '#F9FAFB',
    borderRadius: 10,
    border: '1px solid #E5E7EB',
    [theme.breakpoints.down('sm')]: {
      gap: 8,
      marginBottom: 20,
      padding: '12px 14px',
    },
  },
  benefitItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
    color: '#374151',
    fontSize: 14,
    lineHeight: 1.45,
    [theme.breakpoints.down('sm')]: {
      fontSize: 13,
      gap: 8,
    },
  },
  benefitIcon: {
    color: '#10B981',
    fontWeight: 700,
    fontSize: 15,
    flexShrink: 0,
    marginTop: 1,
  },
  actionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  ctaCard: {
    backgroundColor: '#F0EFFF',
    borderRadius: 8,
    padding: '12px 16px',
    marginBottom: 12,
    border: '1px solid #E0DDFF',
  },
  ctaLine1: {
    fontSize: 14,
    color: '#374151',
    textAlign: 'center',
    lineHeight: 1.5,
    fontWeight: 500,
    marginBottom: 4,
    [theme.breakpoints.down('sm')]: {
      fontSize: 13,
    },
  },
  ctaLine2: {
    fontSize: 13,
    color: '#6B7280',
    textAlign: 'center',
    lineHeight: 1.4,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
    },
  },
  primaryButton: {
    backgroundColor: '#5850EC',
    color: '#ffffff',
    padding: '12px 24px',
    borderRadius: 10,
    fontSize: 16,
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: '0 4px 14px 0 rgba(88, 80, 236, 0.4)',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#4338CA',
      boxShadow: '0 6px 20px 0 rgba(88, 80, 236, 0.5)',
      transform: 'translateY(-1px)',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '11px 20px',
      fontSize: 15,
    },
  },
  secondaryLinkWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 4,
  },
  secondaryLink: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    color: '#5850EC',
    fontSize: 14,
    fontWeight: 500,
    textAlign: 'center',
    textDecoration: 'none',
    padding: '8px 14px',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    transition: 'all 0.15s ease',
    borderRadius: 6,
    '&:hover': {
      backgroundColor: 'rgba(88, 80, 236, 0.08)',
      textDecoration: 'none',
    },
  },
  externalIcon: {
    fontSize: 15,
    opacity: 0.7,
  },
  footer: {
    borderTop: '1px solid #E5E7EB',
    padding: '14px 28px',
    backgroundColor: '#F9FAFB',
    display: 'flex',
    justifyContent: 'center',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      padding: '12px 20px',
    },
  },
  notNowButton: {
    color: '#9CA3AF',
    fontSize: 13,
    fontWeight: 400,
    textTransform: 'none',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    padding: '6px 14px',
    borderRadius: 6,
    transition: 'color 0.15s ease',
    '&:hover': {
      color: '#6B7280',
      backgroundColor: 'transparent',
    },
  },
});

export default pbTextingModalStyle;
